import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Row from '../../../../../core/layout/Row';
import Column from '../../../../../core/layout/Column';
import FormButtons from '../../../../../core/form/FormButtons';
import FetchSelect from '../../../../../core/form/FetchSelect';
import TextInput from '../../../../../core/form/TextInput';

const UnitGrammarsForm = (props) => (
  <form
    onSubmit={(event) => {
      event.preventDefault();
      props.onSubmit();
    }}
  >
    <Row>
      <Column size={12}>
        <FetchSelect
          showSearch
          multiple
          url="grammars"
          disabled={props.submitting || !props.values.id}
          label="Select the grammars to be related to the unit"
          value={get(props.values, 'grammars', '')}
          onChange={(value) => props.onChange('grammars', value)}
          errorText={get(props.errors, 'grammars', '')}
          resultTransformer={{
            text: 'name',
            value: 'id',
          }}
        />
      </Column>
    </Row>
    <Row>
      <Column size={12}>
        <TextInput
          fieldType="textarea"
          textAreaRows={4}
          disabled={props.submitting || !props.values.id}
          label="Image Scenario Prompt"
          value={get(props.values, 'imageScenarioPrompt', '')}
          onChange={(value) => props.onChange('imageScenarioPrompt', value)}
          errorText={get(props.errors, 'imageScenarioPrompt', '')}
        />
      </Column>
    </Row>
    <FormButtons
      confirmLabel="Save"
      isDisabled={props.submitting || !props.isDirty()}
      isSubmitting={props.submitting}
      onReset={props.onReset}
    />
  </form>
);

UnitGrammarsForm.propTypes = {
  onSubmit: PropTypes.func,
  onReset: PropTypes.func,
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  isDirty: PropTypes.func,
};

UnitGrammarsForm.defaultProps = {
  values: {},
  errors: {},
  submitting: false,
  isDirty: () => false,
  onSubmit: () => alert('submitted'),
  onReset: () => false,
};

export default UnitGrammarsForm;
